import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TokenAccordionSummary from "../Deployments/TokenAccordionSummary";
import TokenAccordionDetails from "../Deployments/TokenAccordionDetails";

const ApprovalAccordion = ({ approval, filters }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      disableGutters={true}
      square={true}
      elevation={5}
      expanded={expanded}
      slotProps={{ transition: { timeout: 200 } }}
    >
      <AccordionSummary
        sx={{ pointerEvents: "none" }}
        expandIcon={
          <Button
            sx={{
              pointerEvents: "auto",
              display: { xs: "contents", sm: "inline-flex" },
            }}
            onClick={() => setExpanded((prev) => !prev)}
          >
            <ExpandMoreIcon />
          </Button>
        }
      >
        <TokenAccordionSummary
          token={approval.token}
          filters={filters}
          approval={approval}
        />
      </AccordionSummary>
      <AccordionDetails sx={{ display: "inline-block", width: "100%" }}>
        <TokenAccordionDetails token={approval.token} open={expanded} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ApprovalAccordion;
